"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = match;

var _variant = require("./variant");

function match(variant, switchObject, defaultHandler) {
  if (variant === null || variant === undefined) {
    throw new Error("Variant is not defined");
  }

  if (!Array.isArray(variant)) {
    console.error(`Can't match non-tuple:`, variant);
    throw new Error(`Can't match non-tuple: ${String(variant)}`);
  }

  const fn = switchObject[_variant.V.type(variant)];

  if (!fn) {
    if (typeof defaultHandler === "function") {
      return defaultHandler(_variant.V.type(variant));
    } else {
      const availableKeys = Object.keys(switchObject);
      throw new Error(`type "${_variant.V.type(variant)}" is not in provided switchObject. Included types: ${availableKeys.join(", ")}`);
    }
  }

  return fn(_variant.V.value(variant), _variant.V.type(variant));
}
//# sourceMappingURL=match.js.map